import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
    Session,
    TrainingSessionCompany,
    TrainingSessionCompanyService,
    Registration,
    RegistrationDetailService,
    RegistrationService,
    SessionService,
} from '../../../../../_services';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'registration-company',
    templateUrl: 'registration-company.component.html',
    styleUrls: [
        '../registration.component.scss',
        '../../../../_shared/label/label.component.scss',
    ],
})
export class RegistrationCompanyComponent implements OnInit {
    @Input() tsCompany: TrainingSessionCompany;
    @Input() tsCompanies: TrainingSessionCompany[];
    @Input() session: Session;
    @Output() create: EventEmitter<TrainingSessionCompany> = new EventEmitter();

    newRegistration: any;

    contact: any;

    currency: string;
    price: string;
    billingMode: string;

    showCreateContactPanel: boolean = false;

    private deleteModalRef;

    constructor(
        private registrationDetailsService: RegistrationDetailService,
        private trainingSessionCompanyService: TrainingSessionCompanyService,
        private modalService: NgbModal,
        private sessionService: SessionService
    ) {}

    ngOnInit(): void {
        if (!this.tsCompany) {
            this.tsCompany = {
                name: '',
                selected: false,
                contacts: [],
                editingMode: 'addition',
            };
        } else if (this.tsCompany.contacts.length === 0) {
            this.addContact();
        }
    }

    toggleRegistrationCompany(): void {
        this.updateStudentState();
    }

    updateStudentState() {
        const tsStudents = [].concat.apply(
            [],
            this.tsCompany.contacts.map((contact) => contact.students)
        );
        tsStudents.forEach(
            (student) => (student.selected = !this.tsCompany.selected)
        );
        this.registrationDetailsService.updateRegistrationSelection(
            this.tsCompanies
        );
    }

    companyEdition() {
        this.tsCompany.editingMode = 'edition';
    }

    addContact() {
        this.showCreateContactPanel = true;
    }

    tsContactCreated(createdtsContact) {
        this.showCreateContactPanel = false;
        if (createdtsContact != null) {
            this.tsCompany.contacts.push(createdtsContact);
        }
    }

    confirmChanges(company: TrainingSessionCompany) {
        if (isNaN(parseFloat(this.price))) {
            alert('price unvalid ' + this.price);
            return;
        }
        this.tsCompany.price = parseFloat(this.price) * 100;
        this.saveCompany(company);
    }

    cancel(company: TrainingSessionCompany) {
        company.editingMode = 'cancelEdition';
        this.create.emit(company);
    }

    getNewCompany(event: any) {
        event.editingMode = 'addition';
        event.contacts = [];
        event.salesPerson =
            event.companyExtended && event.companyExtended.commercial;
        this.tsCompany = event;
    }

    getCurrency(event: string) {
        this.currency = event;
    }

    getPrice(event: string) {
        this.price = event;
    }

    getType(event: string) {
        this.billingMode = event;
    }

    getCompanyPrice(company: TrainingSessionCompany) {
        if (company.billingMode === 'BYSTUDENT') {
            return this.registrationDetailsService.getPrice(
                company.price *
                    company.contacts.reduce(
                        (total, contact) => total + contact.students.length,
                        0
                    ),
                company.priceCurrency
            );
        }
        return this.registrationDetailsService.getCompanyPrice(company);
    }

    saveCompany(company: TrainingSessionCompany): void {
        if (!company.registrationId) {
            const companyToCreate = {
                price: company.price,
                priceCurrency: company.priceCurrency
                    ? company.priceCurrency
                    : this.currency,
                billingMode: company.billingMode,
                contacts: [],
                companyId: company.id,
                financed: company.financed,
                financingCompany: company.financingCompany || null,
                commercialName: company.commercialName,
                salesPerson: company.salesPerson,
                orderNumber: company.orderNumber,
            };
            this.sessionService
                .addCompanyToSession(companyToCreate, this.session.id)
                .subscribe((res) => {
                    res.contacts = [];
                    this.create.emit(res);
                });
        } else {
            const companyToUpdate = {
                id: company.id,
                registrationId: company.registrationId,
                price: company.price,
                priceCurrency: company.priceCurrency,
                billingMode: company.billingMode,
                contacts: company.contacts,
                companyId: company.companyId,
                financed: company.financed,
                financingCompany: company.financingCompany || null,
                salesPerson: company.salesPerson,
                orderNumber: company.orderNumber,
            };
            this.sessionService
                .updateCompanyToSession(companyToUpdate, this.session.id)
                .subscribe((res) => {
                    company.editingMode = '';
                    this.create.emit(res);
                });
        }
    }

    isDisabled(
        tsCompany: TrainingSessionCompany,
        price: number,
        billingMode: string
    ) {
        if (!tsCompany.salesPerson || !tsCompany.salesPerson.id) {
            return true;
        }
        if (tsCompany.financed && !tsCompany.financingCompany) {
            return true;
        }
        if (tsCompany.editingMode === 'addition') {
            return !(
                billingMode &&
                tsCompany.id &&
                price + '' != '' &&
                price >= 0
            );
        } else if (tsCompany.editingMode === 'edition') {
            return !(
                tsCompany.billingMode &&
                tsCompany.id &&
                price + '' != '' &&
                price >= 0
            );
        }
    }

    deleteCurrentEditingOption(): void {
        this.closeDeleteModal();

        let index = this.tsCompanies.indexOf(this.tsCompany, 0);

        this.trainingSessionCompanyService
            .delete(this.session.id, this.tsCompany.id)
            .subscribe((_) => {
                if (index > -1) {
                    this.tsCompanies.splice(index, 1);
                }
            });
    }

    closeDeleteModal() {
        this.deleteModalRef.close();
    }

    openDeleteModal(deleteModal) {
        event.stopPropagation();
        this.deleteModalRef = this.modalService.open(deleteModal);
    }

    salesPersonName(company) {
        if (!company.salesPerson) {
            return null;
        }
        const { firstname, lastname } = company.salesPerson;
        return `${firstname} ${lastname}`;
    }

    displayFinancing(tsCompany) {
        return tsCompany.financed
            ? 'session-details.student-tab.financed'
            : 'session-details.student-tab.nonFinanced';
    }

    displayBillingMode(tsCompany) {
        return tsCompany.billingMode == 'BYSTUDENT'
            ? 'session-details.student-tab.byStudent'
            : 'session-details.student-tab.fixedPrice';
    }
}



// WEBPACK FOOTER //
// ./src/app/_screens/session/detail/registration/registration-company/registration-company.component.ts